<template>
    <el-dialog :close-on-click-modal="false" :visible.sync="visible" class="h-dialog6 end-time-dialog" @close="handleClose">
        <div class="h-dialogImg">
            <div class="h-disTable">
                <div class="h-tableCell">
                    <h1>维护不可签收时间</h1>
                </div>
            </div>
        </div>

        <div class="h-formLine">
            <el-form :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                <el-form-item label="产地" class="h-elformWrap-1" required>
                    <brselect placeholder="请选择产地" category="factory" :v="form.factory" :showcode="true"
                              v-model="form.factory" @change="handleFactoryChange" :collapse-tags="true" clearable
                              style="width: 2.6rem;"></brselect>
                </el-form-item>
                <el-form-item label="不可签收时间" class="h-elformWrap-1" required>
                    <div class="h-time-row">
                        <el-date-picker
                                v-model="form.startTime"
                                type="datetime"
                                placeholder="选择开始时间"
                                value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                        <span>至</span>
                        <el-date-picker
                                v-model="form.endTime"
                                type="datetime"
                                placeholder="选择结束时间"
                                value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </div>
                </el-form-item>
            </el-form>
        </div>

        <div class="h-time-btn">
            <el-button class="h-btn h-formBtn h-bgblueQ2" @click="handleSave">保 存</el-button>
        </div>

        <div class="h-formLine" style="padding: 0 0.25rem; margin-bottom: 0.1rem;">
            <h3 style="display: inline-block;">维护记录</h3>
        </div>

        <el-table :data="logList" border style="width: 100%; margin-bottom: 15px;" max-height="400">
            <el-table-column type="index" label="#" width="50"></el-table-column>
            <el-table-column prop="factory" label="产地" min-width="120">
                <template slot-scope="scope">
                    <span v-if="scope.row.factory">[{{ scope.row.factory }}]{{ factoryName(scope.row.factory) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="oldStartDate" label="修改前开始时间" min-width="145"></el-table-column>
            <el-table-column prop="oldEndDate" label="修改前结束时间" min-width="145"></el-table-column>
            <el-table-column prop="newStartDate" label="修改后开始时间" min-width="145"></el-table-column>
            <el-table-column prop="newEndDate" label="修改后结束时间" min-width="145"></el-table-column>
            <el-table-column prop="cuname" label="修改人" width="80"></el-table-column>
            <el-table-column prop="cdate" label="修改时间" min-width="145"></el-table-column>
        </el-table>

        <pagination :page="page" @query="loadLogList"/>

        <div slot="footer" class="dialog-footer">
        </div>
    </el-dialog>
</template>

<script>
import ss from '@/api/SystemService'

export default {
    name: 'EndTimeMaintainDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                factory: '',
                startTime: '',
                endTime: ''
            },
            page: {
                pageNo: 1,
                pageSize: 10,
                total: 0
            },
            logList: []
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.initData()
            }
        }
    },
    methods: {
        // 产地名称（字典翻译，与上方产地下拉的编码+名称格式一致）
        factoryName(code) {
            let list = this.$store.getters.dictlist('factory')
            let item = list.find(r => r.code == code)
            return item ? item.name : ''
        },

        // 初始化表单并加载全部修改记录
        initData() {
            this.form.factory = ''
            this.form.startTime = ''
            this.form.endTime = ''
            this.page.pageNo = 1
            this.page.pageSize = 10
            this.loadLogList()
        },

        // 分页加载修改记录，未选产地时查全部
        loadLogList() {
            let params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize
            }
            if (this.form.factory) {
                params.factory = this.form.factory
            }
            ss.OrderMainService.selectEndTimeLogPage(params).then(rd => {
                this.logList = rd.records || []
                this.page.total = rd.total || 0
            })
        },

        // 产地切换时回填当前生效时间段并按产地过滤记录
        handleFactoryChange() {
            this.page.pageNo = 1
            this.loadLogList()
            if (!this.form.factory) {
                this.form.startTime = ''
                this.form.endTime = ''
                return
            }
            ss.OrderMainService.getLastEndTime({ factory: this.form.factory }).then(rd => {
                if (rd.msg) {
                    this.form.startTime = rd.msg.startDate
                    this.form.endTime = rd.msg.endDate
                }
            })
        },

        // 保存不可签收时间
        handleSave() {
            if (!this.form.factory) {
                this.$msg.msge('请选择产地')
                return
            }
            if (!this.form.startTime || !this.form.endTime) {
                this.$msg.msge('请选择不可签收开始时间和结束时间')
                return
            }
            if (this.form.endTime <= this.form.startTime) {
                this.$msg.msge('结束时间必须大于开始时间')
                return
            }
            this.$confirm('是否确认保存不可签收时间？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    factory: this.form.factory,
                    startTime: this.form.startTime,
                    endTime: this.form.endTime
                }
                ss.OrderMainService.saveEndTimeMaintain(params).then(rd => {
                    if (rd.f) {
                        this.$msg.msgs('保存成功')
                        this.page.pageNo = 1
                        this.loadLogList()
                    } else {
                        this.$msg.msge(rd.msg || '保存失败')
                    }
                })
            }).catch(() => {})
        },

        // 关闭弹窗
        handleClose() {
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style>
/* 维护不可签收时间弹窗样式（标题横幅复用 h-dialog6 宽弹窗设计，此处不覆盖） */
.end-time-dialog .el-table {
    width: 100% !important;
}

/* 保存按钮：单独一行居中展示 */
.end-time-dialog .h-time-btn {
    text-align: center;
    margin-bottom: 15px;
}

/* 底部关闭按钮居中展示 */
.end-time-dialog .el-dialog__footer {
    display: flex;
    justify-content: center;
    text-align: center;
}

/* 表单行：标签与内容同一行不换行，两行标签列固定宽度保持对齐 */
.end-time-dialog .h-formbLine .h-elformWrap-1 {
    display: flex;
    align-items: center;
    padding-right: 0;
}

.end-time-dialog .h-formbLine .h-elformWrap-1 .el-form-item__label {
    width: 1.6rem;
    flex-shrink: 0;
    white-space: nowrap;
    text-align: left;
}

.end-time-dialog .h-formbLine .h-elformWrap-1 .el-form-item__content {
    flex: 1;
    margin-left: 0;
}

/* 时间选择行：单行排列且不被压缩 */
.end-time-dialog .h-time-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
}

.end-time-dialog .h-time-row > * {
    flex-shrink: 0;
    margin-right: 0.12rem;
}

.end-time-dialog .h-time-row > *:last-child {
    margin-right: 0;
}

/* 覆盖全局 .el-date-editor.el-input { width:100% }，保证选中时间完整显示 */
.end-time-dialog .el-form-item__content .el-date-editor.el-input {
    width: 2.8rem !important;
}
</style>
